<template>
  <div class="add-subproject-dialog-wrap">
    <el-dialog
      class="add-subproject-dialog"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="add-subproject-dialog-top">
        <p class="tit">添加已有项目</p>
        <div class="icon-wrap">
          <i class="icon iconfont iconicon_close activeIconHover" @click="handleClose"></i>
        </div>
      </div>

      <div class="add-subproject-dialog-con">
        <el-input
          placeholder="搜索项目名称"
          v-model="param.keyword"
          class="input-search"
          clearable
          prefix-icon="icon iconfont iconicon_search1"
          @input="handleSearch"
        ></el-input>

        <ul v-infinite-scroll="load">
          <li
            v-for="item of subprojectsList"
            :key="item.project_id"
            class="subproject-item"
            :class="{'chos': isChos(item.project_id)}"
            @click="handleChos(item.project_id)"
          >
            {{ item.title }}
            <i v-if="isChos(item.project_id)" class="icon iconfont iconicon_selected"></i>
          </li>
          <nothing v-if="!subprojectsList.length" :config="{ tip: '暂无此项目' }"></nothing>
        </ul>
      </div>

      <div class="add-subproject-dialog-footer">
        <p class="tis" :class="{ 'show-tis' : chosList.length }">
          已选： {{ chosList.length }}个项目
        </p>
        <div class="btn-wrap">
          <span class="cancel text-btn-active" @click="handleClose">取消</span>
          <!-- <wf-button plain @click="handleClose">取消</wf-button> -->
          <wf-button type="primary" :disabled="!chosList.length" @click="handldeAdd">创建</wf-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
//api
import api from '@/services/api/home/home'

export default  {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    crossProjectId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      subprojectsList: [],
      timer: null,
      param: {
        per_page: 10,
        page: 1,
        keyword: ''
      },
      chosList: []
    }
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.init() //获取子项目列表
      }
    }
  },
  methods: {
    async init () {
      const res = await api.getSubprojects(this.param)
      if (res) {
        this.subprojectsList.push(...res.data)
      }
    },
    load() {
      if (this.dialogShow) {
        this.$nextTick(() => {
          this.param.page += 1
          this.init()
        })
      }
    },
    handleChos(id) {
      const _idx = this.chosList.indexOf(id)
      if ( _idx >= 0) {
        //已选
        this.chosList.splice(_idx, 1)
      } else {
        this.chosList.push(id)
      }
    },
    async handldeAdd() {
      if (!this.chosList.length) return
      const param = {
        cross_project_id: this.crossProjectId,
        project_ids: this.chosList
      }
      const res = await api.addDelSubproject(param)
      if (res) {
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.reset()
        this.$emit('update')
      }
    },
    handleSearch() {
      this.debounce(() => {
        this.param.page = 1
        this.reset()
        this.init()
      }, 500)
    },
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    //判断是否该项目以选择
    isChos(id) {
      return this.chosList.indexOf(id) >= 0
    },
    handleClose() {
      this.param.keyword = ''
      this.param.page = 1
      this.reset()
      this.$emit('handleClose', 'addSubprojectDialogShow')
    },
    //重置列表及已选列表
    reset() {
      this.subprojectsList = []
      this.chosList = []
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.add-subproject-dialog-wrap {
  .el-dialog {
    width: 590px;
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 0 !important;
      .add-subproject-dialog-top {
        width: 100%;
        padding: 15px 24px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid  rgba(231,232,237,0.6);
        .tit {
          font-size: 16px;
          font-weight: 500;
          color: #0D1F3C;
        }
        .icon-wrap {
          display: flex;
          i {
            font-size: 16px;
            margin-left: 26px;
            cursor: pointer;
          }
        }
      }
      .add-subproject-dialog-con {
        padding: 18px 24px 0;
        .input-search {
          .el-input__prefix,
          .el-input__suffix {
            i {
              line-height: 32px;
            }
          }
        }
        ul {
          margin: 24px 0 31px;
          height: 384px;
          box-sizing: border-box;
          overflow-y: scroll;
          li {
            width: 100%;
            height: 48px;
            line-height: 48px;
            padding: 0 16px;
            box-sizing: border-box;
            cursor: pointer;
            font-size: 14px;
            font-weight: 400;
            color: #0D1F3C;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:hover {
              @include bgColorOpacity(.04);
            }
            &:active {
              @include bgColorOpacity(.08);
            }
            &.chos {
              i {
                color: #2682FF;
              }
            }
          }
        }
        .nothing-box {
          img {
            width: 123px;
          }
        }
      }
      .add-subproject-dialog-footer {
        width: 100%;
        height: 54px;
        padding: 0 24px 0 40px;
        box-sizing: border-box;
        border-top: 1px solid rgba(231, 232, 237, .6);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tis {
          font-size: 14px;
          color: rgba(13, 31, 60, .6);
          visibility: hidden;
          &.show-tis {
            visibility: visible;
          }
        }
        .btn-wrap {
          display: flex;
          align-items: center;
          .wf-button {
            width: 76px;
            margin-left: 24px;
          }
        }
      }
    }
  }

}
</style>
